function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");
    
    // Loop through the array elements
    for(var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");
        
        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if(name == cookiePair[0].trim()) {
            // Decode the cookie value and return
            return decodeURIComponent(cookiePair[1]);
        }
    }
    
    // Return null if not found
    return null;
}

function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function setProfile(user){

    let user_data ={
             name:   user.displayName,
             uid :   user.uid,
             email:     user.email,
             photo:   user.photoURL,
    };
    setCookie("chat_user",JSON.stringify(user_data),365);
}



function getProfile(){

    return JSON.parse(getCookie("chat_user"));
}

function clearProfile(){
    eraseCookie("chat_user");
}

export {setProfile,getProfile,clearProfile};


// WEBPACK FOOTER //
// ./src/save.js